import React from 'react';
import { areEqual } from 'react-window';
import { useStore } from 'effector-react';
import {
  ImageType,
  type LibItemAlbum,
  type LibItemMatrix,
  LibType,
} from '@types';
import type { ItemListRowProps } from '@components/ItemList';
import Image from '@components/Image';
import LibItemOperator from '../../layouts/LibItemOperator';
import LibItemRightPart from '../../layouts/LibItemRightPart';
import AlbumItem from '../../components/AlbumItem';
import onItemClick from '../../actions/onItemClick';
import LibItemContainer from '../../layouts/LibItemContainer';
import LibItemName from '../../layouts/LibItemName';
import LibItemDate from '../../layouts/LibItemDate';
import ItemCheckBox from '../../components/ItemCheckBox';
import { LibAddedSetGate } from '../../stores/libState';

interface Props extends ItemListRowProps {
  data: {
    albums: LibItemAlbum[];
    items: LibItemMatrix[];
  };
}

function RowMatrix({ index, data, style }: Props) {
  const { albums, items } = data;
  const addedSet = useStore(LibAddedSetGate.state)?.[LibType.matrix];
  const isAlbum = index < albums.length;
  if (isAlbum) {
    const item = albums[index];
    return <AlbumItem style={style} data={item} />;
  }

  const item = items[index - albums.length];

  return (
    <LibItemContainer style={style} onClick={() => onItemClick(item.id)}>
      <ItemCheckBox id={item.id} />
      <Image
        src={item.thumbUrl}
        size={32}
        type={ImageType.thumb}
        className="ml-20 h-32 w-32 cursor-pointer bg-white-border"
      />
      <LibItemName>{item.name}</LibItemName>
      {addedSet?.has(item.id) && (
        <div className="mr-10 shrink-0 text-red">已添加</div>
      )}
      <LibItemRightPart>
        <LibItemOperator name={item.operatorName} />
        <LibItemDate date={item.updateDate} createDate={item.createDate} />
      </LibItemRightPart>
    </LibItemContainer>
  );
}

export default React.memo(RowMatrix, areEqual);
